import { Character } from '../types/character';
import api from '../services/api';

interface APIResponse<T> {
    count: number;
    next: string | null;
    previous: string | null;
    results: T[];
}

interface SingleCharacterResponse {
    data: Character;
}

export const charactersAPI = {
    list: () => 
        api.get<APIResponse<Character>>('/characters/'),
    
    create: (formData: FormData) =>
        api.post<Character>('/characters/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }),
    
    select: (characterId: string) => 
        api.post<SingleCharacterResponse>(
            `/characters/${characterId}/select/`
        ),
}; 